import React from "react";
import { useNavigate } from "react-router-dom";
import World3D from "@/game/world3d/World3D";

export default function City3DPage() {
  const nav = useNavigate();
  return <World3D onExit={() => nav("/city")} />;
}
